import type { ICustomControlDiagnosticReportReadProps } from '../../interfaces/customControlDiagnosticReportReadProps';
import type { IGtcV1DiagnosticReportAddEditCustomControlData } from './GtcV1DiagnosticReportAddEdit';
import { translateKey } from '../../../../../translate';
import { FormParagraph } from '../../../../elements/common';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '../../../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { Icd10SelectionsRead } from '../../utils/v1/Icd10/Icd10SelectionsRead';

export function GtcV1DiagnosticReportSummary(props: ICustomControlDiagnosticReportReadProps) {
    const customControlData: IGtcV1DiagnosticReportAddEditCustomControlData = props.diagnosticReport.customControlData;

    return (
        <>
            <HorizontalFormGroupRead>
                <FormLabel>{translateKey('diagnosticReport.findings')}</FormLabel>
                <FormParagraph bold>{customControlData?.bevindingen}</FormParagraph>
            </HorizontalFormGroupRead>

            <Icd10SelectionsRead
                diagnosis={props.diagnosticReport.diagnosis}
                hideTitle
                showWorkingDiagnosis
                thesaurusTermDate={props.diagnosticReport.dateSent}
            />

            <HorizontalFormGroupRead>
                <FormLabel>{translateKey('diagnosticReport.policy')}</FormLabel>
                <FormParagraph bold>{customControlData?.beleid}</FormParagraph>
            </HorizontalFormGroupRead>

            <HorizontalFormGroupRead>
                <FormLabel>{translateKey('diagnosticReport.visitToSpecialistNecessaryNow')}</FormLabel>
                <FormParagraph bold>{customControlData?.bezoek_aan_specialist_nu_nodig}</FormParagraph>
            </HorizontalFormGroupRead>
        </>
    );
}
